import { useEffect } from 'react'
import { generatePath, useHistory } from 'react-router-dom'

import { colors, GlobalSpinner } from '@scouts/ui'

import config from '@/config'
import {
    PATH_COMPANY_TAX_RETURN,
    PATH_MESSAGES,
    PATH_QUARTERLY_TAX_RETURN,
    PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
    PATH_ROOT,
    PATH_TAX_RETURN,
} from '@/constants'

import { NotificationEventType } from './constants'

const getQueryParams = (queryString: string) => {
    const queryParams = new URLSearchParams(queryString)

    return {
        event: queryParams.get('Event'),
        taxYear: queryParams.get('TaxYear'),
        quarter: queryParams.get('Quarter'),
    }
}

/** Redirects the user to the appropriate page based on the notification type */
const useNotificationRedirect = () => {
    const history = useHistory()

    useEffect(() => {
        const path = (() => {
            const defaultPath = PATH_ROOT

            const { event, taxYear, quarter } = getQueryParams(history.location.search)

            switch (event) {
                case NotificationEventType.MessageFromAccountantToCustomer:
                case NotificationEventType.MessageFromSupportToCustomer:
                    return PATH_MESSAGES

                case NotificationEventType.CompanyAccountsAwaitingCustomerApproval:
                case NotificationEventType.CompanyAccountsFiled:
                case NotificationEventType.CompanyAccountsComplete:
                case NotificationEventType.CompanyBookLegalizationAwaitingCustomerApproval:
                case NotificationEventType.CompanyBookLegalizationFiled:
                case NotificationEventType.CompanyBookLegalizationComplete:
                case NotificationEventType.CompanyTaxReturnAwaitingCustomerApproval:
                case NotificationEventType.CompanyTaxReturnFiled:
                    if (!taxYear) return defaultPath
                    // TODO: Fetch data by CompanyTaxReturnId and then generate path with the taxYear and quarter?
                    return generatePath(PATH_COMPANY_TAX_RETURN, { taxYear })

                case NotificationEventType.QuarterlyTaxReturnAwaitingCustomerApproval:
                case NotificationEventType.QuarterlyTaxReturnFiled:
                    if (!taxYear || !quarter) return defaultPath
                    // TODO: Fetch data by QuarterlyTaxReturnId and then generate path with the taxYear and quarter?
                    return generatePath(PATH_QUARTERLY_TAX_RETURN, { year: taxYear, quarter })

                case NotificationEventType.QuarterlyTaxReturnsAnnualSummaryFiled:
                    if (!taxYear) return defaultPath
                    // TODO: Fetch data by QuarterlyTaxReturnsAnnualSummaryId and then generate path with the taxYear and quarter?
                    return generatePath(PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, { taxYear })

                case NotificationEventType.TaxReturnAwaitingCustomerApproval:
                case NotificationEventType.TaxReturnFiled:
                    if (!taxYear) return defaultPath
                    return generatePath(PATH_TAX_RETURN, { taxYear })

                default:
                    return defaultPath
            }
        })()

        // For navigation triggered by tapping on the mobile notifications,
        // we need to reload the page to ensure the latest data, e.g. messages, is fetched
        window.location.assign(`${config.appBasename}${path}`)

        // Run this effect only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}

export const MobileNotifications = () => {
    useNotificationRedirect()

    return <GlobalSpinner color={colors.surface.affirm} />
}
